/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./css/home.css";
import "./css/styles.css";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import Blog from "./Blog";
class Home extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{this.props.value.title}</title>
          <meta property="og:title" content={this.props.value.title} />

          <meta
            property="og:description"
            content={this.props.value.description}
          />
          <meta property="og:url" content={window.location.href} />
          <link rel="canonical" href={window.location.href} />
          <link rel="alternate" hreflang="en-in" href={window.location.href} />
        </Helmet>

        <div style={{ position: "relative", paddingTop: "80px" }}>
          <img
            src="/assets/images/aiplex-ads-empower-advertiser.png"
            alt="Empower advertiser publishers"
            title="Empower advertiser publishers"
            className="landing_img"
            loading="eager"
          />

          <div className="landing_texthome">
            <h1 className="corporate ltext">
              <span className="first-letter">EMPOWER</span>
              <br />
              <span className="corporate">
                ADVERTISERS & <br />
                PUBLISHERS
              </span>
            </h1>
          </div>
        </div>
        <div className="hrline"></div>
        <div className="container ">
          <div className="row" style={{ paddingLeft: "15px" }}>
            <div className="col-md-4 col-lg-4 padr">
              <div className="card card_size cards rounded text-center">
                <p className="card-title cptop corporate">
                  <span className="first-letter">A</span>dvertisers
                </p>

                <img
                  className="mx-auto d-block border-gray mt-4"
                  src="/assets/images/aiplex-ads-advertiser.png"
                  loading="eager"
                  alt="Advertisers"
                  title="Advertisers"
                />
                <div className="card-body card1 ">
                  <p className="card-text p16  text-justify">
                    Our platform enables you to partner with a diverse range of
                    publishers; content sites, influencers, website owners,
                    technology partners, cashback, coupon companies, etc. You
                    get to choose the right partner to target the right
                    audience.{" "}
                  </p>
                </div>
                <div className="text-center pb-5">
                  <a
                    href="/Advertisers"
                    className="btn btn-color"
                    style={{ color: "white" }}
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 padr">
              <div className="card card_size cards cardimgs rounded text-center">
                <p className="card-title cptop corporate">
                  <span className="first-letter">P</span>ublishers
                </p>

                <img
                  className="mx-auto d-block border-gray mt-4"
                  src="assets/images/aiplex-ads-publisher.png"
                  loading="eager"
                  alt="Publishers"
                  title="Publishers"
                />
                <div className="card-body card2 ">
                  <p className="card-text p16 text-justify">
                    For publishers, AiPlex Ads provides access to millions of
                    products and services across affiliate programs. We connect
                    thousands of leading brands with publishers all over the
                    world with a reliable, transparent and trusted tracking and
                    commission payment mechanism.{" "}
                  </p>
                </div>
                <div className="text-center pb-5">
                  <a
                    href="/Publishers"
                    className="btn btn-color"
                    style={{ color: "white" }}
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-lg-4 padr">
              <div className="card card_size cards rounded text-center">
                <p className="card-title cptop corporate">
                  <span className="first-letter">P</span>rogrammatic
                </p>

                <img
                  className="mx-auto d-block border-gray mt-4"
                  src="assets/images/aiplex-ads-programmatic.png"
                  loading="eager"
                  alt="Programmatic"
                  title="Programmatic"
                />
                <div className="card-body card3 ">
                  <p className="card-text p16 text-justify">
                    Providing programmatic ad solutions to digital advertisers,
                    publishers, and ad agencies across the globe. We help
                    businesses to achieve business goals across all channels,
                    devices and ad formats.
                  </p>
                </div>
                <div className="text-center pb-5">
                  <a
                    href="/Programmatic"
                    className="btn btn-color"
                    style={{ color: "white" }}
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Banner_BG">
          <div className="Banner_padding_home padx">
            <h2 className="corporate text-center t40 ">
              <span className="first-letter">W</span>hy{" "}
              <span className="first-letter">A</span>iplexAds
            </h2>
            <p className="text-center p16">
              An online advertising company that provides access to a global
              network of marketing channels to increase sales, leads, sign-ups,
              app installs, etc. We help you build your brand in any niche,
              anywhere. Our global affiliate marketing network empowers
              advertisers and publishers of all sizes to grow their businesses
              online. You might be a Publisher or an Advertiser; we at AiPlex
              are consumed with doing everything we can to ensure you reach your
              full potential as an affiliate marketer.
            </p>
            <div className="row text-center py-5">
              <div className="col-sm-3 verticalbg">
                <h4 className="py-3 corporate">
                  <span className="first-letter">I</span>nnovation
                </h4>
                <p className="p16">
                  Dedicated to delivering customer-centric innovative solutions
                  and strategies.
                </p>
              </div>
              <div className="col-sm-3 verticalbg ">
                <h4 className="py-3 corporate">
                  <span className="first-letter">P</span>assion
                </h4>
                <p className="p16">
                  Passionate about business growth solutions for both our
                  advertisers and publishers.
                </p>
              </div>
              <div className="col-sm-3 verticalbg">
                <h4 className="py-3 corporate">
                  <span className="first-letter">T</span>rust
                </h4>
                <p className="p16">
                  One of the most trusted and established name in online
                  advertising.
                </p>
              </div>
              <div className="col-sm-3">
                <h4 className="py-3 corporate">
                  <span className="first-letter">R</span>each
                </h4>
                <p className="p16">
                  Access to unparalleled data of global partners and a
                  transparent commercial model.
                </p>
              </div>
            </div>
            <div className="row pt-5">
              <div className="col-sm-6">
                <img
                  src="/assets/images/aiplex-ads-Standout.png"
                  alt="Why AiplexAds"
                  title="Why AiplexAds"
                  loading="lazy"
                  className="img_size"
                />
              </div>
              <div className="col-sm-6">
                <h2 className="corporate h2f  t40 ">
                  <span className="first-letter">S</span>tandout{" "}
                  <span className="first-letter">B</span>y{" "}
                  <span className="first-letter">S</span>taying{" "}
                  <span className="first-letter">A</span>head
                </h2>
                <p className="pt-3 px-2 text-justify p16">
                  With our Advertising Solutions, we help affiliates monetize
                  their inventory very resourcefully. Advertisers will have
                  access to scalable and innovative ideas to get the best out of
                  our platform. AiPlex Ads, as an Ad Network, understands
                  Publishers and Advertisers extremely well. We cultivate
                  mutually-beneficial partnerships between Advertisers and
                  Publishers. Our solutions deliver incremental revenue and are
                  continually tuned to enhance performance. It is simple and
                  easy to sign up; the sign-up process just takes a few minutes
                  before you are approved by our network, and there are no
                  hidden costs. Rest assured you'll appreciate how user-friendly
                  our platform is.
                </p>
              </div>
            </div>
            <div className="row pt-5">
              <div className="col-sm-6 ">
                <h2 className="corporate h2f  t40 ">
                  <span className="first-letter">O</span>ne{" "}
                  <span className="fisrt-letter">O</span>f the{" "}
                  <span className="first-letter">L</span>eading B2B{" "}
                  <span className="first-letter">D</span>igital Solutions
                  Providers
                </h2>
                <p className="pt-3 px-2 text-justify p16">
                  We come with a long-term commitment and credibility; we are in
                  business since 2003. A company that successfully operates 3
                  digital verticals providing solutions to some of the biggest
                  names in the entertainment industry across India and
                  worldwide, i.e., Antipiracy, Digital Marketing Agency & Online
                  Advertising Services. We are a team of 150+ full-time
                  employees with an in-house Digital R&D team. Signed up with
                  1000+ high-quality Publishers from India and worldwide and
                  signing up with 100+ new publishers every month. Assuring
                  timely and transparent pay outs. A platform that is easy to
                  integrate on your website; we can set up things in minutes.
                </p>
              </div>
              <div className="col-sm-6">
                <img
                  src="/assets/images/aiplex-ads-leading-solution.png"
                  alt="One Of the Leading B2B Digital Solutions Providers"
                  title="One Of the Leading B2B Digital Solutions Providers"
                  loading="lazy"
                  className="img_size"
                />
              </div>
            </div>
            <div className="row pt-5  pb-5">
              <div className="col-sm-12">
                <img
                  src="/assets/images/aiplex-ads-why-aiplex.png"
                  loading="lazy"
                  alt="whyaiplex"
                  title="why aiplex?"
                  width="100%"
                />
              </div>

              <div className="desktop_view text-center pt-5">
                <div className="row hwwr d-flex justify-content-center">
                  <div className="col-sm-4 ">
                    <div className="box bpad">
                      <img
                        src="/assets/images/what_we_are.png"
                        loading="lazy"
                        alt="what we are"
                        title="what we are"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">W</span>HAT{" "}
                        <span className="first-letter">W</span>E{" "}
                        <span className="first-letter">A</span>RE
                        <br />
                      </h4>

                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            We are an Online Advertising company that is
                            focussed on maximizing the ROI of both advertisers
                            and affiliates. We create trusted partnerships that
                            drive growth.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 ">
                    <div className="box bpad">
                      <img
                        src="/assets/images/what_we_offer.png"
                        loading="lazy"
                        alt="what we offer"
                        title="what we offer"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">W</span>HAT{" "}
                        <span className="first-letter">W</span>E{" "}
                        <span className="first-letter">O</span>FFER
                        <br />
                      </h4>
                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            We take your campaigns to the next level. We are in
                            the business of helping you drive revenue and
                            growth. Your success will define how successful we
                            are.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 ">
                    <div className="box bpad">
                      <img
                        src="/assets/images/top_quality_traffic.png"
                        loading="lazy"
                        alt="top quality traffic"
                        title="top quality traffic"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">T</span>OP{" "}
                        <span className="first-letter">Q</span>UALITY{" "}
                        <span className="first-letter">T</span>RAFFIC
                        <br />
                      </h4>
                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            We have one of the strictest affiliate approval
                            processes in the industry. We ensure that your offer
                            will only be promoted by high-quality affiliates. We
                            are also able to provide our customers with premier
                            international traffic from over 100 different
                            countries.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="box bpad">
                      <img
                        src="/assets/images/top_performing_options.png"
                        loading="lazy"
                        alt="top performing options"
                        title="top performing options"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">T</span>OP{" "}
                        <span className="first-letter">P</span>ERFORMING{" "}
                        <span className="first-letter">O</span>PTIONS
                        <br />
                      </h4>
                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            With our diverse selection of options across more
                            verticals than any other network, you are sure to
                            find high-converting options for your audience. We
                            also offer a large variety of international options
                            for more than 100 different countries.
                          </p>
                        </div>
                      </div>
                    </div>{" "}
                  </div>
                  <div className="col-sm-4 ">
                    <div className="box bpad">
                      <img
                        src="/assets/images/weekly_payment.png"
                        alt="weekly payment"
                        title="weekly payment"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">W</span>EEKLY{" "}
                        <span className="first-letter">P</span>AYMENT <br />{" "}
                        <span className="first-letter">F</span>OR{" "}
                        <span className="first-letter">Q</span>UALIFIED{" "}
                        <span className="first-letter">T</span>RAFFIC <br />
                      </h4>
                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            We offer performance-based preferential payment
                            options for our clients. Affiliates achieving
                            certain targets in weekly commissions are offered
                            weekly payment privileges. With vast experience in
                            generating users for some of the top brands, we can
                            customize a performance-based campaign specific to
                            any advertiser’s needs. Our User Generation model
                            yields highly reliable ROI for any campaign
                            requiring a specific cost per action. Receive what
                            you earn faster. We guarantee you'll be paid on
                            time, every single week, so that your budget stays
                            replenished. Be recognized for being exceptional. We
                            offer our best affiliates additional earnings
                            through numerous performance-based rewards.
                          </p>
                        </div>
                      </div>
                    </div>{" "}
                  </div>
                  <div className="col-sm-4 ">
                    <div className="box bpad">
                      <img
                        src="/assets/images/affiliative_support.png"
                        alt="affiliative support"
                        title="affiliative support"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">U</span>NFLINCHING <br />
                        <span className="first-letter">A</span>FFILIATE{" "}
                        <span className="first-letter">S</span>UPPORT
                        <br />
                      </h4>
                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            We handle all tracking, reporting, payment,
                            full-service management or self-service management
                            of a program. We provide access to thousands of
                            affiliate programs. Irrespective of what your
                            requirement is, our affiliate managers are your
                            number one resource for helping you generate the
                            highest revenue possible. The entire team at AiPlex
                            is dedicated to your success.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-4 ">
                    <div className="box bpad">
                      <img
                        src="/assets/images/complience.png"
                        alt="compliance"
                        title="compliance"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">C</span>OMPLIANCE <br />
                      </h4>
                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            Our team ensures that your brand is always marketed
                            ethically and fairly. A full-time compliance team
                            will continually monitor your offer's traffic to
                            assure that quality standards are met. We
                            proactively review traffic, identifying possible
                            low-quality issues before they affect lead quality.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="box bpad">
                      <img
                        src="/assets/images/cost_per_action.png"
                        alt="cost_per_action"
                        title="cost_per_action"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">C</span>OST{" "}
                        <span className="first-letter">P</span>ER{" "}
                        <span className="first-letter">A</span>CTION <br />
                      </h4>
                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            CPA Advertising is a valuable alternative to
                            traditional CPM - you only pay for results. As a CPA
                            lead-generation affiliate network, we provide you
                            with the opportunity to promote your offer to a vast
                            audience of potential customers, and only pay for
                            the leads that you receive. Your product or service
                            is positioned in front of consumers by leveraging
                            massive social followings, visitor-rich websites,
                            expansive e-mail lists, and media buying expertise
                            to extend your reach to the right consumers at the
                            right places. As a publisher, promote
                            high-converting cost‑per‑action campaigns from
                            hundreds of advertisers seeking your blogging,
                            media-buying, social media, and e-mail marketing
                            expertise.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 ">
                    <div className="box bpad ">
                      <img
                        src="/assets/images/rich_dashboard.png"
                        loading="lazy"
                        alt="rich_dashboard"
                        title="rich_dashboard"
                      />
                      <h4 className="corporate pt-3">
                        <span className="first-letter">F</span>EATURE-
                        <span className="first-letter">R</span>ICH <br />
                        <span className="first-letter">D</span>ASHBOARD
                        <br />
                      </h4>
                      <div>
                        <a
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="/assets/images/buttton.png"
                            loading="lazy"
                            alt="button"
                            title="button"
                          />
                        </a>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <p className="px-2 p16">
                            Stay updated on the newest and most popular
                            campaigns while tracking your earnings with our
                            advanced reports.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mobile_view col-12">
                <div className="col-sm-12 mx-auto pt-5">
                  <div
                    className="accordion"
                    id="accordionExample"
                    style={{ textAlign: "center" }}
                  >
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            WHAT WE ARE
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapseOne"
                        className="collapse show"
                        aria-labelledby="headingOne"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          We are an Online Advertising company that is focussed
                          on maximizing the ROI of both advertisers and
                          affiliates. We create trusted partnerships that drive
                          growth.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            WHAT WE OFFER
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapseTwo"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          We take your campaigns to the next level. We are in
                          the business of helping you drive revenue and growth.
                          Your success will define how successful we are.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingThree">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            UNFLINCHING AFFILIATE SUPPORT
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapseThree"
                        className="collapse"
                        aria-labelledby="headingThree"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          We handle all tracking, reporting, payment,
                          full-service management or self-service management of
                          a program. We provide access to thousands of affiliate
                          programs. Irrespective of what your requirement is,
                          our affiliate managers are your number one resource
                          for helping you generate the highest revenue possible.
                          The entire team at AiPlex is dedicated to your
                          success.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingfour">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapsefour"
                            aria-expanded="false"
                            aria-controls="collapsefour"
                          >
                            TOP PERFORMING OPTIONS
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapsefour"
                        className="collapse"
                        aria-labelledby="headingfour"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          With our diverse selection of options across more
                          verticals than any other network, you are sure to find
                          high-converting options for your audience. We also
                          offer a large variety of international options for
                          more than 100 different countries.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingfive">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapsefive"
                            aria-expanded="false"
                            aria-controls="collapsefive"
                          >
                            WEEKLY PAYMENT FOR QUALIFIED TRAFFIC{" "}
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapsefive"
                        className="collapse"
                        aria-labelledby="headingfive"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          We offer performance-based preferential payment
                          options for our clients. Affiliates achieving certain
                          targets in weekly commissions are offered weekly
                          payment privileges. With vast experience in generating
                          users for some of the top brands, we can customize a
                          performance-based campaign specific to any
                          advertiser’s needs. Our User Generation model yields
                          highly reliable ROI for any campaign requiring a
                          specific cost per action. Receive what you earn
                          faster. We guarantee you'll be paid on time, every
                          single week, so that your budget stays replenished. Be
                          recognized for being exceptional. We offer our best
                          affiliates additional earnings through numerous
                          performance-based rewards.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingsix">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapsesix"
                            aria-expanded="false"
                            aria-controls="collapsesix"
                          >
                            TOP QUALITY TRAFFIC{" "}
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapsesix"
                        className="collapse"
                        aria-labelledby="headingsix"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          We have one of the strictest affiliate approval
                          processes in the industry. We ensure that your offer
                          will only be promoted by high-quality affiliates. We
                          are also able to provide our customers with premier
                          international traffic from over 100 different
                          countries.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingseven">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseseven"
                            aria-expanded="false"
                            aria-controls="collapseseven"
                          >
                            COMPLIANCE{" "}
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapseseven"
                        className="collapse"
                        aria-labelledby="headingseven"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          Our team ensures that your brand is always marketed
                          ethically and fairly. A full-time compliance team will
                          continually monitor your offer's traffic to assure
                          that quality standards are met. We proactively review
                          traffic, identifying possible low-quality issues
                          before they affect lead quality.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingeight">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseeight"
                            aria-expanded="false"
                            aria-controls="collapseeight"
                          >
                            COST PER ACTION{" "}
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapseeight"
                        className="collapse"
                        aria-labelledby="headingeight"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          CPA Advertising is a valuable alternative to
                          traditional CPM - you only pay for results. As a CPA
                          lead-generation affiliate network, we provide you with
                          the opportunity to promote your offer to a vast
                          audience of potential customers, and only pay for the
                          leads that you receive. Your product or service is
                          positioned in front of consumers by leveraging massive
                          social followings, visitor-rich websites, expansive
                          e-mail lists, and media buying expertise to extend
                          your reach to the right consumers at the right places.
                          As a publisher, promote high-converting
                          cost‑per‑action campaigns from hundreds of advertisers
                          seeking your blogging, media-buying, social media, and
                          e-mail marketing expertise.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingnine">
                        <h2 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapsenine"
                            aria-expanded="false"
                            aria-controls="collapsenine"
                          >
                            FEATURE-RICH DASHBOARD{" "}
                          </button>
                        </h2>
                      </div>
                      <div
                        id="collapsenine"
                        className="collapse"
                        aria-labelledby="headingnine"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body p16">
                          Stay updated on the newest and most popular campaigns
                          while tracking your earnings with our advanced
                          reports.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hrline"></div>

        <div className="consult">
          <div
            className="Banner_padding2 bpadding2"
            style={{ paddingBottom: " 10px", paddingTop: " 70px" }}
          >
            <div className="row">
              <div className="col-md-7">
                <h2>
                  <strong>Ready to get started?</strong>
                </h2>
                <h3>
                  Learn how AiPlex Digital can solve <br />
                  your more complex needs
                </h3>
              </div>
              <div className="col-md-3 float-bottom">
                <a className="btn btn-primary1 " href="#contact">
                  Get In Touch
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="hrline"></div>
        {/* <div className="col-12 pt-5 blogcontainer" style={{backgroundColor:'whitesmoke'}}>
<p className="corporate t40 lh1">
                  <span className="first-latter">T</span>he 
                  <span className="first-latter"> A</span>iPlex 
                  <span className="first-latter"> B</span>log
                </p> 
    <Blog/>


</div> */}

        <div className="hrline"></div>
      </div>
    );
  }
}
Home.propTypes = {
  value: PropTypes.object.isRequired,
};
export default Home;
